import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ContractsService} from 'app/contract-closing-commons/services/contracts.service';
import {ContractDetailsModel} from 'app/contract-closing-commons/models/contract-details.model';
import {Utilities} from 'app/shared/utilities/utilities.model';
import {Router} from '@angular/router';
import {ROOT_CONTRACT_CLOSING_SP, ROOT_DELIVERY} from '../../../app-routing-roots';
import {CCSPO_CONTRACT_DETAILS, CCSPO_CONTRACTS_LIST, CCSPO_DASHBOARD} from '@cc-sp-operator/cc-sp-routing-roots';
import {OrderService} from '../../../delivery/services/order.service';
import {OrderResponseDetails} from '../../../delivery/models/orders-response.model';
import {OrderDetails} from '../../../delivery/models/order-details.model';
import {DL_DASHBOARD, DL_ORDER_DETAILS, DL_ORDERS_LIST} from '../../../delivery/delivery-routing-roots';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-header-details',
	templateUrl: './header-details.component.html',
	styleUrls: ['./header-details.component.scss'],
	providers: [ContractsService, OrderService]
})
export class HeaderDetailsComponent implements OnChanges {
	@Input() id: string | number;
	@Input() headerDetailsType: ETypeHeaderDetails;

	endState: number = ContractDetailsModel.CLOSED_ID;
	orderID: number;
	contractNumber: string;
	contract: ContractDetailsModel;
	orderDetails: OrderDetails;
	translateContext = TranslateContext;

	constructor(public router: Router,
				public contractService: ContractsService,
				public orderService: OrderService) {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!Utilities.isVoid(changes.headerDetailsType)) {
			this.headerDetailsType = changes.headerDetailsType.currentValue;
		}
		if (!Utilities.isVoid(changes.id)) {
			this.id = changes.id.currentValue;
			if (!Utilities.isVoid(this.id)) {
				switch (this.headerDetailsType) {
					case ETypeHeaderDetails.Contract:
						this.contractNumber = this.id as string;
						this.getContract();
						break;
					case ETypeHeaderDetails.Order:
						this.orderID = this.id as number;
						this.getOrder();
						break;
				}
			}
		}
	}

	getContract(): void {
		this.contractService.getContractDetails(this.contractNumber).subscribe(
			contract => {
				this.contract = contract;
			}
		);
	}

	getOrder(): void {
		this.orderService.getOrderDetails(this.orderID).subscribe(
			(response: OrderResponseDetails) => {
				if (response.responseStatus === 200) {
					this.orderDetails = response.value;
				}
			}
		);
	}

	onClickItem(): void {
		let route: string = '';
		switch (this.headerDetailsType) {
			case ETypeHeaderDetails.Contract:
				route = '/' + ROOT_CONTRACT_CLOSING_SP + '/' + CCSPO_DASHBOARD + '/' + CCSPO_CONTRACTS_LIST + '/' + CCSPO_CONTRACT_DETAILS;
				break;
			case ETypeHeaderDetails.Order:
				route = '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD + '/' + DL_ORDERS_LIST + '/' + DL_ORDER_DETAILS;
				break;
		}
		this.router.navigate([route, this.id]).then();

	}
}

export enum ETypeHeaderDetails {
	Contract, Order
}
